import { feature, useFeature } from '@/app/context';
import type { SnapshotFrom } from 'xstate';
import type { RouteId, schedulesMachine } from './schedules.machine';

export const useSchedulesRef = () => feature('schedules');

export const useSchedules = <R>(selector: (snapshot: SnapshotFrom<typeof schedulesMachine>) => R) =>
  useFeature('schedules', selector);

export const useSchedulesActions = () => {
  const ref = useSchedulesRef();
  return {
    chooseRoute: (routeId: RouteId) => ref.send({ type: 'schedule.choose-route', routeId }),
    chooseDirection: (directionId: string) => ref.send({ type: 'schedule.choose-direction', directionId }),
    chooseStop: (stopId: string) => ref.send({ type: 'schedule.choose-stop', stopId }),
    rememberChoice: () => ref.send({ type: 'schedule.remember-choice' }),
    refreshArrivals: () => ref.send({ type: 'schedule.refresh-arrivals' }),
  };
};
